import { render, staticRenderFns } from "./DeviceStatus.vue?vue&type=template&id=fe5973bc&scoped=true&"
import script from "./DeviceStatus.vue?vue&type=script&lang=js&"
export * from "./DeviceStatus.vue?vue&type=script&lang=js&"
import style0 from "./DeviceStatus.vue?vue&type=style&index=0&id=fe5973bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5973bc",
  null
  
)

export default component.exports